/* istanbul ignore file */

export const WIDGET_MANDATORY_READ = 'mandatory-read';
